import { render, staticRenderFns } from "./LoaderCircle.vue?vue&type=template&id=74fe34ec&scoped=true&"
var script = {}
import style0 from "./LoaderCircle.vue?vue&type=style&index=0&id=74fe34ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fe34ec",
  null
  
)

export default component.exports